import React from "react"
import { CheckmarkIcon } from "components/page-components/Icons/small"

export const NoticeWizardProgress = ({ wizard_step }) => {
  return (
    <div className="columns is-vcentered is-mobile">
      <div className="column is-narrow">
        <div
          className={`has-background-${
            !!wizard_step ? "success" : "mitternachtsblau"
          } has-text-weight-bold step`}
        >
          {!!wizard_step ? (
            <CheckmarkIcon
              {...{ size: 0.4, strokeWidth: "6", color: "#FFFFFF" }}
            />
          ) : (
            "1"
          )}
        </div>
      </div>
      <div className="column">
        <progress
          className={`progress wizard-progress${
            wizard_step === 0 ? "-delayed" : ""
          } is-${!!wizard_step ? "success" : "mitternachtsblau"} is-slim`}
          value={!!wizard_step ? "4" : "1"}
          max="4"
        ></progress>
      </div>
      <div className="column is-narrow">
        <div
          className={`has-background-${
            wizard_step === 2
              ? "success"
              : !!wizard_step
              ? "mitternachtsblau"
              : "mitternachtsblau-30"
          } has-text-weight-bold step`}
        >
          {wizard_step === 2 ? (
            <CheckmarkIcon
              {...{ size: 0.4, strokeWidth: "6", color: "#FFFFFF" }}
            />
          ) : (
            "2"
          )}
        </div>
      </div>
      <div className="column">
        <progress
          className={`progress wizard-progress${
            wizard_step === 1 ? "-delayed" : ""
          } is-${
            !!wizard_step && wizard_step === 2 ? "success" : "mitternachtsblau"
          } is-slim`}
          value={wizard_step === 2 ? "4" : !!wizard_step ? "1" : "0"}
          max="4"
        ></progress>
      </div>
      <div className="column is-narrow">
        <div
          className={`has-background-mitternachtsblau${
            wizard_step !== 2 ? "-30" : ""
          } has-text-weight-bold step`}
        >
          3
        </div>
      </div>
    </div>
  )
}
